// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type MoneyBackGuarantee24FilledProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const MoneyBackGuarantee24Filled: FC<MoneyBackGuarantee24FilledProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="24"
            height="24"
        >
            <path d="M10.125 20H4c-.55 0-1.02-.196-1.413-.587A1.926 1.926 0 0 1 2 18V6c0-.55.196-1.02.587-1.412A1.926 1.926 0 0 1 4 4h16c.55 0 1.02.196 1.413.588.391.391.587.862.587 1.412v6h-2.725l-4.325 4.325-2.85-2.8-4.225 4.225 2.25 2.25Zm4.825 2-4.25-4.25 1.4-1.4 2.85 2.8 5.65-5.65 1.4 1.45L14.95 22ZM4 8v4h16V8H4Z" />
        </svg>
    );
};

export default MoneyBackGuarantee24Filled;
